export var AssignmentType;

(function (AssignmentType) {
  AssignmentType["Practice"] = "1";
  AssignmentType["Examination"] = "3";
})(AssignmentType || (AssignmentType = {}));

export var getAssignmentTypeName = function getAssignmentTypeName(assignmentType) {
  switch (assignmentType) {
    case AssignmentType.Practice:
      return 'Practice';

    case AssignmentType.Examination:
      return 'Examination';

    default:
      return 'Practice';
  }
};
export var getTranslatedTypeName = function getTranslatedTypeName(typeId, originalName, translation) {
  switch (typeId) {
    case '1':
      return translation.assignmentTypePractice;

    case '3':
      return translation.assignmentTypeExamination;

    default:
      return originalName;
  }
};